// src/features/guias/components/EditGuiaModal.jsx
import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { Button } from "components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "components/ui/dialog";
import { Input } from "components/ui/input";
import { Label } from "components/ui/label";
import toast from "react-hot-toast";

function EditGuiaModal({ isOpen, onClose, onSave, guiaData }) {
  const { register, handleSubmit, reset } = useForm();

  useEffect(() => {
    if (guiaData) {
      reset({
        name: guiaData.name,
        phone: guiaData.phone,
      });
    }
  }, [guiaData, reset]);

  const onSubmit = async (data) => {
    if (!data.name) {
      toast.error("Nome é obrigatório.");
      return;
    }

    await onSave({
      ...data,
      phone: guiaData.phone, // Telefone não é editável, pois é a chave do documento
    });
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent aria-describedby={undefined} className="w-full h-[100dvh] max-h-none sm:h-auto sm:max-h-[85vh] sm:max-w-md p-0 border-0 sm:border rounded-none sm:rounded-lg overflow-hidden flex flex-col">
        <DialogHeader className="px-6 py-4 border-b shrink-0 bg-white dark:bg-background">
          <DialogTitle>Editar Guia</DialogTitle>
        </DialogHeader>
        <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col flex-1 overflow-hidden">
          <div className="flex-1 overflow-y-auto px-6 py-4 grid gap-4 content-start">
            <div className="grid grid-cols-4 items-center gap-4">
              <Label htmlFor="name" className="text-right">
                Nome
              </Label>
              <Input
                id="name"
                {...register("name", { required: "Nome é obrigatório" })}
                className="col-span-3"
              />
            </div>

            <div className="grid grid-cols-4 items-center gap-4">
              <Label htmlFor="phone" className="text-right">
                Telefone
              </Label>
              <Input
                id="phone"
                {...register("phone")}
                className="col-span-3 bg-gray-100 text-gray-500 cursor-not-allowed dark:bg-gray-800 dark:text-gray-400"
                disabled
                title="Para mudar o telefone, exclua e crie novamente."
              />
            </div>
          </div>
          <DialogFooter className="px-6 py-4 border-t shrink-0 bg-gray-50 dark:bg-card mt-auto">
            <Button type="submit" className="w-full sm:w-auto">Salvar Alterações</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}

export default EditGuiaModal;
